/**
 * Every page the site has. The pre-render walks LOCALES x ROUTES, and the same list drives
 * sitemap.xml (F6), so a page cannot exist without being indexable.
 */
export const ROUTES = ["/", "/privacy", "/terms"] as const;

export type RoutePath = (typeof ROUTES)[number];

/**
 * The security atlas: one English-only static page (`public/security-atlas/`, generated by
 * `todo/cryptico-architecture-visualization/Cryptico-Security-Atlas-EN/build.py`). It is NOT in
 * ROUTES because it is not pre-rendered per locale; the host lists it in sitemap.xml itself.
 * Ends in a slash for the same reason as `localeHref` below.
 */
export const SECURITY_ATLAS_HREF = "/security-atlas/";

export function isRoutePath(value: string): value is RoutePath {
  return (ROUTES as readonly string[]).includes(value);
}

/**
 * `/uk` + `/privacy` -> `/uk/privacy/`. Every page URL on this site ends in a slash.
 *
 * ❗ THE SLASH IS NOT COSMETIC AND IT MUST NOT COME BACK OFF. Every route is a DIRECTORY holding
 * an index.html, and the host redirects a directory reached without the slash — 301 to the
 * slashed form. This function feeds the canonical tag, the hreflang set, the sitemap and every
 * link on the page, so while it emitted `/uk/privacy` the site advertised 48 URLs that answered
 * a redirect rather than the page, and the canonical tag on `/uk/privacy/` pointed away from
 * itself at that redirect. The rule is simply: what we advertise is what answers 200.
 */
export function localeHref(locale: string, path: RoutePath): string {
  return path === "/" ? `/${locale}/` : `/${locale}${path}/`;
}
